import { useIntl } from "react-intl";
import React from "react";
import HistoquimicaContainer from "./histo.container";

function HistoquimicaContainerIntl() {
    const intl = useIntl()
    return (
        <HistoquimicaContainer intl={intl}></HistoquimicaContainer>
    );
  }

  export default HistoquimicaContainerIntl


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/histo/histo.intl.js